import { render, staticRenderFns } from "./TaskResponseEditor.vue?vue&type=template&id=404fcde8&"
import script from "./TaskResponseEditor.vue?vue&type=script&lang=js&"
export * from "./TaskResponseEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports